import { ReactElement, useCallback } from 'react';

import { DocplannerHealthcareProviderConfiguration } from '@dreryk/egabinet-docplanner-frontend-api';

import { useBoolean } from '@dreryk/react-common';
import { EditIcon, Link } from '@dreryk/react-components';

import { integrationTranslationKeys } from '../../translations';

import { DocplannerUpdateSynchronizationDaysCountModal } from './DocplannerUpdateSynchronizationDaysCountModal';

type DocplannerUpdateSynchronizationDaysCountProps = {
   readonly currentSynchronizationDaysCount: number;
   readonly onDaysCountUpdated: (currentDocplannerConfiguration: DocplannerHealthcareProviderConfiguration) => void;
};

export const DocplannerUpdateSynchronizationDaysCount = (
   props: DocplannerUpdateSynchronizationDaysCountProps
): ReactElement => {
   const { onDaysCountUpdated } = props;
   const [
      { setTrue: openUpdateSynchronizationDaysCountModal, setFalse: closeUpdateSynchronizationDaysCountModal },
      updateSynchronizationDaysCountModalOpened,
   ] = useBoolean(false);

   const handleSuccess = useCallback(
      (currentDocplannerConfiguration: DocplannerHealthcareProviderConfiguration) => {
         onDaysCountUpdated(currentDocplannerConfiguration);
         closeUpdateSynchronizationDaysCountModal();
      },
      [onDaysCountUpdated, closeUpdateSynchronizationDaysCountModal]
   );

   return (
      <>
         <Link
            testId={'updateSynchronizationDaysCount'}
            label={integrationTranslationKeys.updateDaysCount}
            onClick={openUpdateSynchronizationDaysCountModal}
            icon={<EditIcon />}
         />
         {updateSynchronizationDaysCountModalOpened ? (
            <DocplannerUpdateSynchronizationDaysCountModal
               currentSynchronizationDaysCount={props.currentSynchronizationDaysCount}
               onClose={closeUpdateSynchronizationDaysCountModal}
               onSubmitSuccess={handleSuccess}
            />
         ) : null}
      </>
   );
};
